/**
 * The Settings home launcher: the panel opens the way Intercom's does, with a
 * loose Home entry above the first group header pointing at the searchable
 * landing page.
 */
export default ({ t, accountScopedRoute }) => ({
  name: 'Settings Home',
  label: t('SIDEBAR.SETTINGS_HOME'),
  icon: 'i-ph-house',
  to: accountScopedRoute('settings_home'),
});
